import React, { useState } from "react";
import './HiringForm.css';
import axios from "axios";

const HiringForm = () => {
  const [hireData, setHireData] = useState({
    name: "",
    email: "",
    phone: "",
    booking_type: "", // Individual or Group
    event_type: "",
    event_datetime: "",
    event_duration: "",
    event_location: "",
    shoot_package: "",
    add_ons: [],
    payment_method: "",
    accept_terms: false,
  });

  const checkAvailability = async(event_datetime) => {
    try {
        const response = await axios.get(`/api/routine/check-availibilty?event_datetime=${event_datetime}`);
        if(response.data.search === true && response.data.availability === true) {
            console.log("Available")
            return true;
        } else {
            return false;
        }
    } catch (error) {
        console.log("Error", error)
    }
  }

  const handleInput = async (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "datetime-local") {
        const availability = await checkAvailability(value);

        if (!availability) {
            alert("Sorry, this time slot is not available.");
            return;
        }
    }

    setHireData((prevData) => ({
        ...prevData,
        [name]: type === "checkbox" ? checked : value,
        ...(name === "add_ons" && { 
            add_ons: checked
                ? [...prevData.add_ons, value]
                : prevData.add_ons.filter((item) => item !== value)
        }),
    }));
};


  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("HD", hireData)
    const response = await axios.post('/api/hiring/hire-request', hireData);

    if(!response.data.submit) {
        alert("Sorry, Could Not Mark Booking.");
    } else {
        alert("Booking Successfully Marked.");
    }
  };

  return (
    <div className="form-page">
      <form onSubmit={handleSubmit} className="hiringForm">
        <h3>📌 Personal Details</h3>
        <label>Name:</label>
        <input
          name="name"
          type="text"
          value={hireData.name}
          onChange={handleInput}
          placeholder="Enter Full Name"
          required
        />
        <br />
        <label>Email:</label>
        <input
          name="email"
          type="email"
          value={hireData.email}
          onChange={handleInput}
          placeholder="Enter Email for Confirmation"
          required
        />
        <br />
        <label>Phone:</label>
        <input
          name="phone"
          type="tel"
          value={hireData.phone}
          onChange={handleInput}
          placeholder="Enter Phone Number"
          required
        />
        <br />

        <label>Booking Type:</label>
        <select name="booking_type" value={hireData.booking_type} onChange={handleInput}>
          <option value="">Select</option>
          <option value="Group">Group</option>
          <option value="Individual">Individual</option>
        </select>
        <br />

        <h3>📌 Event Details</h3>
        <label>Event Type:</label>
        <select name="event_type" value={hireData.event_type} onChange={handleInput}>
          <option value="">Select Event Type</option>
          <option value="Wedding">Wedding</option>
          <option value="Portrait">Portrait</option>
          <option value="Product">Product</option>
          <option value="Corporate Event">Corporate Event</option>
          <option value="Birthday">Birthday</option>
          <option value="Other">Other</option>
        </select>
        <br />

        <label>Date & Time of Event:</label>
        <input
          type="datetime-local"
          name="event_datetime"
          value={hireData.event_datetime}
          onChange={handleInput}
          required
        />
        <br />

        <label>Event Duration (Hours):</label>
        <input
          type="number"
          name="event_duration"
          value={hireData.event_duration}
          onChange={handleInput}
          placeholder="Enter Expected Duration"
          required
        />
        <br />

        <label>Event Location:</label>
        <textarea
          name="event_location"
          value={hireData.event_location}
          onChange={handleInput}
          placeholder="Enter Location Details"
          required
        />
        <br />

        <h3>📌 Package Selection</h3>
        <label>Photography Package:</label>
        <select name="shoot_package" value={hireData.shoot_package} onChange={handleInput}>
          <option value="">Select Package</option>
          <option value="Basic">Basic (2-hour shoot, 30 edited photos)</option>
          <option value="Premium">Premium (4-hour shoot, 60 edited photos)</option>
          <option value="Custom">Custom (Tailor your needs)</option>
        </select>
        <br />

        <h3>📌 Add-ons (Optional)</h3>
        <label>
          <input
            type="checkbox"
            name="add_ons"
            value="Videography"
            checked={hireData.add_ons.includes("Videography")}
            onChange={handleInput}
          />
          Videography
        </label>
        <br />
        <label>
          <input
            type="checkbox"
            name="add_ons"
            value="Drone Shots"
            checked={hireData.add_ons.includes("Drone Shots")}
            onChange={handleInput}
          />
          Drone Shots
        </label>
        <br />
        <label>
          <input
            type="checkbox"
            name="add_ons"
            value="Extra Edited Photos"
            checked={hireData.add_ons.includes("Extra Edited Photos")}
            onChange={handleInput}
          />
          Extra Edited Photos
        </label>
        <br />
        <label>
          <input
            type="checkbox"
            name="add_ons"
            value="Printed Albums"
            checked={hireData.add_ons.includes("Printed Albums")}
            onChange={handleInput}
          />
          Printed Albums
        </label>
        <br />

        <h3>📌 Payment Details</h3>
        <label>Preferred Payment Method:</label>
        <select name="payment_method" value={hireData.payment_method} onChange={handleInput}>
          <option value="">Select Payment Method</option>
          <option value="Bank Transfer">Bank Transfer</option>
          <option value="Cash">Cash</option>
          <option value="Online Payment">Online Payment</option>
        </select>
        <br />

        <h3>📌 Terms & Conditions</h3>
        <label>
          <input
            type="checkbox"
            name="accept_terms"
            checked={hireData.accept_terms}
            onChange={handleInput}
            required
          />
          I agree to the terms and conditions.
        </label>
        <br />

        <button type="submit">Submit Booking</button>
      </form>
    </div>
  );
};

export default HiringForm;
